module.exports = __webpack_public_path__ + "img/student_help_real_world.7d8084de.jpg";